import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-location-disclosure",
  templateUrl: "./location-disclosure.component.html",
  styleUrls: ["./location-disclosure.component.scss"],
  standalone: false,
})
export class LocationDisclosureComponent {
  constructor(private modalCtrl: ModalController) {}

  accept() {
    return this.modalCtrl.dismiss("accept", "accept");
  }

  decline() {
    return this.modalCtrl.dismiss("decline", "decline");
  }
}
